import completed from "assets/images/completed.png";
import inprogress from "assets/images/in-progress.png";
import pending from "assets/images/pending.png";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Card, CardBody, CardHeader, CardImg, CardText, CardTitle
} from "reactstrap";
import { API_URL } from "../Constants"; // Import API_URL
import ReactGA from 'react-ga';
import teamIcon from 'assets/images/teamIcon.png';

class ScheduleTable extends Component {
  constructor() {
    super();
    this.state = {
      data: [],
      homeTeamName: undefined,
      courtNo: undefined,
      teams: [],
      courts: [],
    };
    ReactGA.event({
      category: 'Schedules',
      action: 'Open'

    });
  }

  componentDidMount() {
    fetch(`${API_URL}/app/api/v1/schedules?filter=scheduleGroup.status==A`)
      .then((results) => {
        return results.json();
      })
      .then((resp) => {
        const teamsList = new Set();
        resp.forEach(e => teamsList.add(e.homeTeamName));
        resp.forEach(e => teamsList.add(e.visitorTeamName));
        this.setState({
          data: resp,
          teams: [...teamsList].sort(),
          courts: [...new Set(resp.map((item) => item.courtNo))].sort(),
        });
      });
  }

  handleSubmit = (variable, source) => {
    debugger;
    fetch(
      `${API_URL}/app/api/v1/schedules?filter=scheduleGroup.status==A`
    )
      .then((results) => {
        // if(results){

        // }
        return results.json();
      })
      .then((resp) => {
        this.setState({ [source]: variable }, () => {
          const { homeTeamName, courtNo } = this.state;
          // console.log(this.state.teams);
          // console.log("Court: " + courtNo + "    Team: " + homeTeamName);
          const filter = resp.filter((item) => {
            if(courtNo && courtNo !== 'Select Court' && homeTeamName && homeTeamName !== 'Select Team') {
              // console.log("Applied both filters");
              return (item.courtNo === courtNo && (item.homeTeamName === homeTeamName || item.visitorTeamName === homeTeamName));
            } else if(courtNo && courtNo !== 'Select Court' && (!homeTeamName || homeTeamName === 'Select Team')) {
              //apply only rounds filter
              // console.log("Applied court filters");
              return item.courtNo === courtNo;
            } else if(homeTeamName && homeTeamName !== 'Select Team' && (!courtNo || courtNo === 'Select Court')) {
              //apply only team filter
              // console.log("Applied team filter");
              return (item.homeTeamName === homeTeamName || item.visitorTeamName === homeTeamName);
            } else {
              // console.log("Applied NO filters");
              return true;
            }            
          });
          //update state data with updated filters
          this.setState({ data: filter });
        });
      });
  };

  render() {
    return (
      <div className="card">
        <div className="header">
          <h4 className="title">Schedule</h4>
          <p className="category">User Filter to limit results</p>
          <select
            value={this.state.round}
            onChange={(e) =>
              this.handleSubmit(Number(e.target.value), "courtNo")
            }
          >
            <option name="0"> Select Court</option>
            {this.state.courts.map((item) => (
              <option name={item}>{item}</option>
            ))}
          </select>
          <select
            value={this.state.homeTeamName}
            onChange={(e) => this.handleSubmit(e.target.value, "homeTeamName")}
          >
            <option name="0"> Select Team</option>
            {this.state.teams.map((item) => (
              <option name={item}>{item}</option>
            ))}
          </select>
        </div>
        {this.state.data.map((item) => (
          <Card className="m-2 px-3 py-2">
            <CardHeader tag="h6">
              <CardImg width={30} className="me-2" src={teamIcon} alt="Card image cap" /> {item.homeTeamName} vs. {item.visitorTeamName}
            </CardHeader>
            <CardBody>
              <CardTitle>{item.round}</CardTitle>
              <CardText>Court: {item.courtNo}</CardText>
              <CardText>Round: {item.round}</CardText>
              <CardText>{item.scheduleDate}</CardText>
              <CardText>
                {(() => {
                  if (item.gameEntry != null) {
                    switch (item.gameEntry.status) {
                      case "A":
                        return <CardImg width="50px" src={inprogress} />;
                      case "I":
                        return <CardImg width="50px" src={completed} />;
                      default:
                        return <CardImg width="50px" src={pending} />;
                    }
                  } else {
                    return <CardImg width="50px" src={pending} />;
                  }
                })()}
              </CardText>
            </CardBody>
          </Card>
        ))}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.Auth.user,
});

export default connect(mapStateToProps)(ScheduleTable);


// WEBPACK FOOTER //
// ./src/components/Table/ScheduleTable.js